import React from 'react';
import styled from 'styled-components';

import { colors } from '../../../../healtheraComponents';

const ImagesList = ({ currentImage, images, onPick }) => {
  const createClickHandler = image => () => {
    onPick(image);
  };

  return (
    <Container>
      {images.map(image => (
        <ImageButton
          disabled={currentImage.name === image.name}
          key={image._id}
          onClick={createClickHandler(image)}
        >
          <Image src={image.url} alt={image.name} />
        </ImageButton>
      ))}
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 10px;
`;

const ImageButton = styled.button`
  border: none;
  background: none;

  opacity: 1;
  cursor: pointer;

  transition: opacity 0.1s ease;

  &:hover {
    opacity: 0.6;
  }

  &:active {
    opacity: 0.3;
  }

  ${({ disabled }) =>
    disabled &&
    `
    border: 1px solid ${colors.HEALTHERA_GREEN};
    border-radius: 50%;
    cursor: default;

    &:hover, &:active { opacity: 1; } 
  `}
`;

const Image = styled.img`
  width: 100px;
  height: 100px;
  object-fit: contain;
`;

export default ImagesList;
